import { API } from "aws-amplify";


const showLatest = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    let items = await API.get("InasakuAPI", "/inasaku/weather-infos", myInit);
    return items;
};
const showHistories = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    let items = await API.get("InasakuAPI", "/inasaku/weather-histories", myInit);
    return items;
};
const showAccumulation = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    let items = await API.get("InasakuAPI", "/inasaku/weather-accumulations", myInit);
    return items;
};
const showHourlyHistories = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    let items = await API.get("InasakuAPI", "/inasaku/weather-hourly-histories", myInit);
    return items;
};

const init = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params,
        }, // replace this with attributes you need
        headers: {} // OPTIONAL
    };
    let items = await API.post("InasakuAPI", "/inasaku/create-weather-infos", myInit);
    return items;
};
export default {
    showLatest,
    showHistories,
    showAccumulation,
    showHourlyHistories,
    init,
};
